import React, { useState, useEffect } from "react";
import "./App.css";

import { Box, ThemeProvider } from "@mui/material";
import { styled } from "@mui/system";
import theme from "./themes/muiTheme";
import { PdfViewer } from "./components/Viewer";
import { IndexDrawer } from "./components/IndexDrawer/index";
import { DrawerButton } from "./components/Buttons/DrawerButton";

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const ViewerContainer = styled(Box)`
  display: flex;
  height: {
    lg: "100vh";
    xs: "100dvh";
  }
  width: "100vw";
  flex: 1;
  overflow-x: hidden;
`;

function App() {
  const [allPage, setAllPages] = useState(1);
  const [page, setPage] = useState(0);

  const [responsiveScale, setResponsiveScale] = useState(1.0);
  const { height, width } = useWindowDimensions();
  const [isShowDrawer, setIsShowDrawer] = useState(false);
  const [expanded, setExpanded] = React.useState<string | false>("Me");

  const [isPortrait, setIsPortrait] = useState(false);

  useEffect(() => {
    var isPortrait = getIsPortrait(window.screen.orientation.type);
    setIsPortrait(isPortrait);
    setIsShowDrawer(!isPortrait);
  }, []);

  window.addEventListener("orientationchange", () => {
    var orientation = window.screen.orientation;
    setIsPortrait(getIsPortrait(orientation.type));
  });

  useEffect(() => {
    let widthScale: number = width / 1290;
    let heightScale: number = height / 600;

    let scale =
      widthScale < 0 || heightScale < 0 ? Number(widthScale.toFixed(2)) : 1;

    setResponsiveScale(scale);
  }, [width]);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: { lg: "100vh", xs: "100dvh" },
          flexDirection: "column",
        }}
      >
        <DrawerButton
          isPortrait={isPortrait}
          isShowDrawer={isShowDrawer}
          setIsOpenDrawer={setIsShowDrawer}
        />
        <ViewerContainer>
          <PdfViewer
            currentPage={page}
            allPage={allPage}
            isShowDrawer={isShowDrawer}
            setPage={setPage}
            setAllPages={setAllPages}
          />
          <IndexDrawer
            pageWidth={width}
            currentPage={page}
            isOpen={isShowDrawer}
            isPortrait={isPortrait}
            setPage={setPage}
            setExpanded={setExpanded}
            setIsDrawerOpen={setIsShowDrawer}
          />
        </ViewerContainer>
      </Box>
    </ThemeProvider>
  );
}

export default App;

function getIsPortrait(orientation: string) {
  return (
    orientation === "portrait-primary" || orientation === "portrait-secondary"
  );
}
